// Other positions not implemented yet
export enum BadgePosition {
   TopRight
}
